import React, { useEffect, useState } from 'react';

import { FORM_ERROR } from 'final-form';
import { isNil } from 'ramda';
import { Field, Form } from 'react-final-form';
import { useHistory } from 'react-router';
import { useQueryParam } from 'use-query-params';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import FormErrorText from 'components/shared/FormErrorText';
import AuthTitle from 'components/shared/Typography/AuthTitle';
import { GENERAL_ERROR_MESSAGE } from 'constants/texts';
import { useSnackbar } from 'hooks/useSnackbar';
import useValidationSchema from 'hooks/useValidationSchema';
import { axiosAuth } from 'utils/axios';
import logger from 'utils/logger';

import { GP_AUTH_SIGNIN_ROUTE } from '../../Routes/constants';
import { useGuestPortalRouteBuilder } from '../../Routes/functions';
import AuthLabel from '../components';
import { validationSchema } from './validationSchema';

function Signup() {
  const history = useHistory();
  const onSnackbar = useSnackbar();
  const validate = useValidationSchema(validationSchema);
  const { buildRoute } = useGuestPortalRouteBuilder();
  const [emailQueryParam, setEmailQueryParam] = useQueryParam('email');
  const [predefinedEmail] = useState(emailQueryParam || undefined);

  const handleSubmit = async ({ inviteId, password, passwordConfirmation } = {}) => {
    try {
      await axiosAuth.patch(`auth/invitation/${inviteId.trim()}/guest`, {
        password,
        passwordConfirmation,
      });
      history.push(buildRoute(GP_AUTH_SIGNIN_ROUTE, { email: predefinedEmail }));
      onSnackbar('Your password has been set successfully.');
    } catch (err) {
      logger.error(err);

      return {
        inviteId: err?.response?.status === 404 ? 'The code is invalid or expired' : undefined,
        [FORM_ERROR]: err?.response?.status === 404 ? undefined : GENERAL_ERROR_MESSAGE,
      };
    }
  };

  useEffect(() => {
    if (isNil(emailQueryParam)) {
      return;
    }

    setEmailQueryParam(undefined);
  }, []);

  return (
    <Form onSubmit={handleSubmit} validate={validate}>
      {({ handleSubmit, submitting, hasValidationErrors, submitError }) => {
        return (
          <form onSubmit={handleSubmit} autoComplete="off">
            <AuthTitle>Set password to get started</AuthTitle>

            <AuthLabel>Enter code from email</AuthLabel>
            <Field
              component={FormGroupAdapter}
              name="inviteId"
              placeholder="Code"
              type="text"
              autoComplete="one-time-code"
            />

            <AuthLabel>Set Password</AuthLabel>
            <Field
              component={FormGroupAdapter}
              name="password"
              placeholder="Password"
              type="password"
              withIcon
              autoComplete="new-password"
              withPasswordRequirementsTip
            />

            <AuthLabel>Confirm Password</AuthLabel>
            <Field
              component={FormGroupAdapter}
              name="passwordConfirmation"
              placeholder="Confirm Password"
              type="password"
              withIcon
              noMargin
              autoComplete="new-password"
            />

            {<FormErrorText>{submitError}</FormErrorText>}

            <FormActions isRight>
              <Button htmlType="submit" disabled={submitting || hasValidationErrors}>
                Submit
              </Button>
            </FormActions>
          </form>
        );
      }}
    </Form>
  );
}

export default Signup;
